import React from 'react';
import BJstandard from '../../../imgs/BJstandard.webp'; 
import './Bjstandard.css';
import { Link } from 'react-router-dom';
import Reqprodcte from "../../../components/Reqprodcte"; 

const Bjstandard = () => {
  return (
    <div className="bjstand-container">
      {/* Left Side - Text */}
      <div className="bjstan-text">
        <h2 className="bj-texte-servi">BJ SERIES</h2>
        <h3 className="text-lg font-semibold text-gray-700">Standard Injection Molding Machine</h3>
        <p className="text-gray-600">
          With the new driving system for our standard injection molding machine, BJ Series saves more energy than before. 
          The motor will stop at the stage of cooling to save energy and also provides higher injection accuracy and speed.
        </p>
        <ul className="clamp-1">
          <li><strong>Clamping Force:</strong> 50~1380 Ton</li>
          <li><strong>Driving System:</strong> Hydraulic</li>
          <li><strong>Motor Type:</strong> Servo or Variable</li>
          <li><strong>Applications:</strong> Food & Beverage Packaging, Necessities Products, Home Appliances, Electrical Components, Automotive Parts</li>
        </ul>
         <div className='stnd'>
                            <Reqprodcte />
                        </div>
         
      </div>

      {/* Right Side - Image */}
      <div className="bjstan-img">
        <img 
          src={BJstandard} 
          alt="BJ Series Injection Molding Machine" 
          className="bjstan-imgs"
        />
      </div>
    </div>
  );
};

export default Bjstandard;
